import { Check } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

import type { FilterOptionTone, FilterSectionOption } from '../model/filter-sections';

const TONE_CLASSES: Record<FilterOptionTone, string> = {
  teal: 'border border-cyan-600 text-cyan-600',
  red: 'border border-destructive text-destructive',
  green: 'border border-green-700 text-green-700',
};

type Props = {
  option: FilterSectionOption;
  checked: boolean;
  onToggle: () => void;
};

const FilterOptionRow = ({ option, checked, onToggle }: Props) => {
  const Icon = option.icon;

  return (
    <Button
      variant="ghost"
      role="checkbox"
      aria-checked={checked}
      onClick={onToggle}
      className={cn(
        'h-auto w-full justify-start gap-2 rounded-md border border-transparent px-2 py-2 text-left text-sm font-semibold',
        checked && 'border-cyan-600 bg-teal-50 hover:bg-teal-50',
      )}
    >
      <span
        className={cn(
          'flex size-6.5 shrink-0 items-center justify-center rounded-md',
          option.tone && TONE_CLASSES[option.tone],
        )}
      >
        <Icon className={`${option.iconSize ?? 'size-3.25'}!`} />
      </span>
      <span className="flex-1">{option.label}</span>
      {checked && <Check className="size-4 shrink-0 text-teal-600" />}
    </Button>
  );
};

export default FilterOptionRow;
